import {
  ADD_COURSE_KNOWLEDGE,
  ADD_COURSE_KNOWLEDGE_SUCCESS,
  ADD_COURSE_KNOWLEDGE_CLEAN,
  ADD_COURSE_KNOWLEDGE_ERROR,
} from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  done: false,
  courseKnowledge: {},
}

const CourseKnowledge = (state = initialState, action) => {
  switch (action.type) {
    case ADD_COURSE_KNOWLEDGE:
      state = {
        ...state,
        loading: true,
      }
      break
    case ADD_COURSE_KNOWLEDGE_SUCCESS:
      state = {
        ...state,
        courseKnowledge: action.payload.courseKnowledge,
        loading: false,
        done: true,
      }
      break
    case ADD_COURSE_KNOWLEDGE_CLEAN:
      state = initialState
      break
    case ADD_COURSE_KNOWLEDGE_ERROR:
      state = { ...state, error: action.payload, loading: false, done: true }
      break
    default:
      state = { ...state }
      break
  }
  return state
}

export default CourseKnowledge
